import { useMemo } from "react"

import { useMatch } from "react-router-dom"

import { MapLegend } from "@l2r-front/l2r-map"

import { useRiskZonesLegend } from "../../../modules/riskZones/hooks/useRiskZonesLegend"
import { useSpeedingsLegend } from "../../../modules/speedings/hooks/useSpeedingsLegend"
import { APP_SAFETY } from "../../constants/appSafety"
import { MODULE_RISK_ZONES, MODULE_SPEEDINGS } from "../../constants/modules"

export function SafetyMapLegend() {

    const matchRiskZones = useMatch(`:slug/${APP_SAFETY}/${MODULE_RISK_ZONES}/*`)
    const matchSpeedings = useMatch(`:slug/${APP_SAFETY}/${MODULE_SPEEDINGS}/*`)

    const riskZonesLegend = useRiskZonesLegend()
    const speedingsLegend = useSpeedingsLegend()

    const displayedLegend = useMemo(() => {

        if (matchRiskZones) {
            return riskZonesLegend
        }
        if (matchSpeedings) {
            return speedingsLegend
        }

        return null

    }, [matchRiskZones, matchSpeedings, riskZonesLegend, speedingsLegend])

    if (displayedLegend) {
        return <MapLegend displayedLegends={displayedLegend} />
    }

    return []
}